module.exports = __webpack_public_path__ + "img/cartowe.24d59d1c.webp";